import React from 'react';

export const Location: React.FC<React.HTMLAttributes<SVGElement>> = (props) => (
  <svg viewBox="2 2 20 20" {...props}>
    <path
      fillRule="evenodd"
      fill="currentColor"
      d="M17 8.821C17 12.583 12 20 12 20S7 12.689 7 8.821a5 5 0 0110 0z M15.047 8.8a3.107 3.107 0 11-3.1-2.9 3 3 0 013.1 2.9z"
    />
  </svg>
);
